import { useEffect, useState } from 'react'

const useIsTactile = (instanceId?: string): boolean => {
  const [current, setCurrent] = useState<boolean>(false)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_isTactile', (e) => handleChange(e))
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_isTactile'))

    return () => {
      document.removeEventListener('retorik_isTactile', (e) => handleChange(e))
    }
  }, [])

  return current
}

export default useIsTactile
